<template>
    <div class="order-status-page page-details" v-if="userAuthenticated" style="height:100vh">
        <job-navigation :loading="loading" :fixedToTop="true" @closePage="closePage" :title="orderStatusData.title"
                        :sub-title="orderStatusData.customerOrderId"></job-navigation>

        <div class="wrapper" v-show="!loading">
            <div class="main-col" v-scroll-spy="{offset: 80, time: 500}">
                <div class="box main-data">
                    <div v-if="orderStatusData.paymentTransaction" class="row">
                        <div class="col-email">
                            Tranzakció: #{{ orderStatusData.paymentTransaction.id }}
                            <br><br>
                        </div>
                        <div class="text-info-bold">
                            {{
                                orderStatusData.paymentTransaction.is_pending
                                    ? 'Folyamatban'
                                    : orderStatusData.paymentStatusTrans
                            }}
                            <br><br>
                        </div>
                        <div v-if="orderStatusData.paymentStatus === 'failed'" class="col-comment">
                            Kérjük, ellenőrizze a tranzakció során megadott adatok helyességét. Amennyiben minden adatot helyesen adott meg, a visszautasítás okának kivizsgálása kapcsán kérjük, szíveskedjen kapcsolatba lépni kártyakibocsátó bankjával.
                            <br>
                        </div>
                        <div class="col-comment">
                            Fizetési mód: {{ orderStatusData.paymentTransaction.gateway_trans }}
                        </div>
                        <div class="col-comment">
                            SimplePay tranzakció azonosító: {{ orderStatusData.paymentTransaction.transaction_id }}
                        </div>
                        <div class="col-comment">
                            Létrehozva: {{ orderStatusData.paymentTransaction.created_at_formatted }}
                        </div>
                        <div v-if="orderStatusData.paymentTransaction.completed_at" class="col-comment">
                            Sikeresnek jelölve: {{ orderStatusData.paymentTransaction.completed_at_formatted }}
                        </div>
                        <div v-if="orderStatusData.paymentTransaction.failed_at" class="col-comment">
                            Sikertelennek jelölve: {{ orderStatusData.paymentTransaction.failed_at_formatted }}
                        </div>
                        <div class="text-info-bold">
                            <br>
                            Összesen: {{ orderStatusData.paymentTransaction.total | formatPrice }} Ft
                        </div>
                    </div>

                    <div class="row row-buttons">
                        <button
                            class="btn btn-secondary"
                            type="button"
                            @click="closePage">
                            Vissza
                        </button>
                        <button v-if="paymentTransactions.length > 1" class="btn btn-plain btn-plain-wicon button-details" type="button" @click="openHistory = !openHistory">
                            <span>További tranzakciók</span>
                            <md-icon v-show="openHistory">expand_less</md-icon>
                            <md-icon v-show="!openHistory">expand_more</md-icon>
                        </button>
                    </div>
                    <div class="row row-history" v-show="openHistory">
                        <div v-for="payment in paymentTransactions" :key="payment.id" class="row-history-element">
                            <div class="col-status">{{ payment.gateway_trans }}</div>
                            <div class="col-person">{{ payment.transaction_id }}</div>
                            <div class="col-date">{{ payment.created_at_formatted }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="is-loading" v-show="loading"></div>

        <notification></notification>
    </div>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'

// import { stickyColHandler } from '../plugins/helpers.js'
import {MdIcon} from 'vue-material/dist/components'
import VTooltip from 'v-tooltip'
import Scrollspy from 'vue2-scrollspy'

import JobNavigation from '../components/navigations/JobNavigation.vue'
import Notification from '../components/Notification.vue'
import ProgressBar from '../components/ProgressBar.vue'
import ModalConfirmation from '../components/modals/ModalConfirmation.vue'
import OrderStatus from "@/pages/OrderStatus.vue";

Vue.use(MdIcon)
Vue.use(VTooltip)
Vue.use(Scrollspy)

export default {
    name: 'OrderPaymentStatus',

    data() {
        return {
            loading: true,
            details: this.$store.state.orderDetails,
            openProductsTable: true,
            openHistory: false,
            orderStatusData: {
                permissions: {}
            },
            items: null,
            gateway: null,
            gateways: null,
            order: null,
            paymentTransaction: null,
            transactionUrl: null,
        }
    },

    mounted() {
        this.$store.dispatch('FETCH_CURRENT_USER').then(() => {
            window.scrollTo(0, 0);
            this.fetchOrderStatus()
        }).catch((redirect) => {
            redirect && this.$router.push({name: 'OrderList'})
        })
    },

    watch: {
        '$route'() {
            this.fetchOrderStatus()
        },
    },

    methods: {
        async finishTransaction() {
            const query = this.$route.query;

            if (! query.orderId || (query.orderId !== this.$route.params.orderId)) {
                return
            }

            let message = {
                id: query.orderId,
                // transactionId: query.transactionId,
                // status: query.status,
                ...query
            }

            this.loading = true

            // /complete or /invalidate
            await this.$store.dispatch('ORDER_FINISH_TRANSACTION', message).then((resp) => {
                this.loading = false

                /*
                resp
                'orderId' => $this->order->id,
                'gateway' => $this->getActiveGateway(),
                'transactionId' => $paymentTransaction->transaction_id,
                'paymentTransactionId' => $paymentTransaction?->id,
                or 'redirect'
                 */
                if (resp.redirect) {
                    const url = new URL(resp.redirect)
                    url.search = new URLSearchParams(message).toString()
                    window.location.href = url.toString()
                }

            }).catch((err) => {
                console.log('ORDER_FINISH_TRANSACTION')
                console.error(err)
                // this.$router.push({name: 'OrderStatus', params: {orderId: this.$route.params.orderId}})
            })
        },
        async fetchOrderStatus() {
            await this.finishTransaction();

            const params = this.$route.params;

            if (! params.orderId) {
                return
            }

            let message = {
                id: params.orderId,
                type: 'order'
            }

            this.loading = true

            this.$store.dispatch('FETCH_ORDER_DETAILS', message); // Setting order details

            this.$store.dispatch('FETCH_ORDER_STATUS', message).then(() => {
                this.orderStatusData = this.orderStatus
                this.loading = false
            }).catch(() => {
                this.$router.push({name: 'OrderStatus', params: {orderId: this.$route.params.orderId}})
            })
        },

        closePage() {
            this.$router.push({name: 'OrderStatus', params: {orderId: this.$route.params.orderId}})
        }
    },

    computed: {
        paymentTransactions() {
            if (!this.orderStatusData.paymentTransactions) {
                return []
            }

            return this.orderStatusData.paymentTransactions.filter(payment => payment.gateway !== 'pending')
        },

        ...mapGetters(['orderStatus', 'orderDetails', 'userHasObjects', 'userAuthenticated'])
    },

    components: {
        JobNavigation, Notification, ProgressBar, ModalConfirmation
    }
}
</script>

<style lang="scss">
@import '../assets/sass/ui/tooltip.scss';
</style>

<style lang="scss" scoped>
@import '../assets/sass/toolkit.scss';
@import '../assets/sass/layout/page-details.scss';
@import '../assets/sass/ui/input.scss';
@import '../assets/sass/ui/button.scss';
@import '../assets/sass/ui/box.scss';
@import '../assets/sass/ui/table.scss';
@import '../assets/sass/ui/navbar.scss';
@import '../assets/sass/ui/loading.scss';

.order-status-page {
    background: $color-gray-bg-1;
    overflow: hidden;
    padding-top: 60px;
    padding-bottom: 100px;

    .box {
        padding: 0;
    }

    .table {
        width: 100%;
    }

    .row {
        padding: 30px 40px 30px 40px;
    }

    .label {
        font-size: 10px;
        font-weight: bold;
        text-transform: uppercase;
        color: $color-gray-4;
        display: block;
        margin-bottom: 10px;
    }

    .main-data {
        margin-top: 32px;

        .row-progress {
            background: $color-gray-bg-1;
            border-bottom: 1px solid $color-gray-border;
        }

        .row-notify {
            background: rgba(255, 255, 0, 0.2);
            border-bottom: 1px solid $color-gray-border;
            height: 22px;
            line-height: 22px;
            font-size: 13px;
            color: $color-gray-2;
            text-align: center;
            font-weight: bold;
            padding: 0;
            margin: 0;
            text-transform: uppercase;
        }

        .row-buttons {
            display: flex;
            align-items: flex-start;
            border-bottom: 1px solid $color-gray-border;
            padding-top: 20px;
            padding-bottom: 20px;

            @media only screen and (max-width: 600px) {
                flex-direction: column;
                align-items: flex-start;
            }

            button {
                height: 40px;
            }

            .button-details {
                font-size: 14px;
                margin-left: 22px;

                i {
                    position: relative;
                    top: 2px;
                    font-size: 17px !important;
                }
            }

            .col-edit {
                display: flex;
                flex-direction: column;
                margin-left: auto;
                margin-right: 0;

                @media only screen and (max-width: 600px) {
                    margin-left: 0px;
                    align-items: baseline;
                }

                button {
                    height: auto;
                    margin: 0;
                    text-align: right;
                }
            }
        }

        .row-history {
            background: $color-gray-bg-1;
            padding-top: 25px;
            padding-bottom: 20px;

            .row-history-element {
                display: flex;
                font-size: 13px;
                border-bottom: 1px dashed $color-gray-border;
                padding-bottom: 15px;
                margin-bottom: 15px;

                &:last-child {
                    margin-bottom: 5px;
                    border: 0;
                    padding: 0;
                }

                .col-status {
                    width: 30%;
                    font-weight: bold;
                }

                .col-person {
                    width: 45%;

                    span {
                        display: block;
                    }
                }

                .col-date {
                    width: 25%;
                    text-align: right;
                }
            }
        }
    }

    .order-data {
        [class^="col-"] {
            width: 33.33%;
            font-weight: 500;
        }

        .row-identification {
            display: flex;
            padding-top: 20px;
            padding-bottom: 20px;
            border-bottom: 1px solid $color-gray-border;

            .col-id,
            .col-object {
                border-right: 1px dashed $color-gray-border;
            }

            .col-object,
            .col-date {
                text-align: center;
            }

            .col-object {
                .btn {
                    display: inline-block;
                    font-weight: bold;
                    font-size: 16px;
                    line-height: 1;
                    margin: 3px 0;

                    i {
                        font-size: 14px !important;
                        margin-left: -3px;
                    }
                }
            }
        }

        .row-customer {
            display: flex;
            align-items: center;
            padding-top: 20px;
            padding-bottom: 20px;

            .col-name {
                font-size: 14px;

                .customer-number {
                    display: inline-block;
                    font-family: $font-primary;
                    margin-top: 5px;
                }
            }

            .col-phone,
            .col-email {
                font-size: 15px;
                font-family: $font-primary;
                text-align: center;

                .btn {
                    font-size: 15px;
                }
            }
        }
    }

    .shipping-data {
        [class^="col-"] {
            width: 50%;
            font-weight: 500;
        }

        .row {
            display: flex;
            border-bottom: 1px solid $color-gray-border;

            .col-time {
                padding-left: 15%;
            }

            .col-address,
            .col-recipient {
                font-size: 15px;

                span:last-child {
                    display: block;
                    font-family: $font-primary;
                    margin-top: 5px;
                    line-height: 1.2;
                }
            }

            .col-address {
                border-right: 1px dashed $color-gray-border;
                padding-right: 15px;
            }

            .col-recipient {
                padding-left: 15%;
            }

            .col-amount {
                padding-left: 15%;
                font-family: $font-primary;

                span {
                    font-weight: bold;
                }
            }

            .col-comment {
                width: 100%;
                font-family: $font-primary;
                font-size: 15px;
                line-height: 1.4;
            }
        }

    }

    .text-info-discounts {
        margin-bottom: 30px;
        font-size: 15px;
    }

    .discounts-data {
        margin-bottom: 50px;

        th,
        td {
            &:nth-child(1) {
                width: 75%;
            }

            &:nth-child(2) {
                width: 25%;
            }
        }

        td {
            &:nth-child(2) {
                font-weight: bold;
            }
        }
    }

    .products-data {
        margin-bottom: 20px;

        th,
        td {
            line-height: 20px;

            strong {
                font-weight: bold;
            }

            &:nth-child(1) {
                width: 50%;
            }

            &:nth-child(2) {
                width: 25%;
            }

            &.sub-discounts {
                font-size: 13px;
            }
        }
    }

    .btn-collapse-products {
        text-decoration: none;
        margin-left: 18px;

        span {
            text-decoration: underline;
            font-size: 14px;
        }

        i {
            font-size: 20px !important;
        }
    }
}
</style>
